export const recentTrips = [
  {
    item_id: 1,
    trip_name: 'Nikhik-Sanjana-London itinerary',
    address: {
      city: 'london',
      country: 'United Kingdom',
    },
    start_date: '10-04-2022',
    end_date: '10-12-2022',
    total_guest: 3,
    price: '1,60,909',
    currency: 'INR',
    email: 'nikhil@gmail.com',
    tags: ['Family trip', 'Adventure'],
  },
  {
    item_id: 2,
    trip_name: '5 Days Bali Trip',
    address: {
      city: 'Bali',
      country: 'Indonesia',
    },
    start_date: '10-04-2022',
    end_date: '10-12-2022',
    total_guest: 3,
    price: '1,60,909',
    currency: 'INR',
    email: 'bali@gmail.com',
    tags: ['Family trip', 'Adventure'],
  },
  {
    item_id: 3,
    trip_name: '5 days Australia Trip',
    address: {
      city: 'Melbourne',
      country: 'Australia',
    },
    start_date: '10-04-2022',
    end_date: '10-12-2022',
    total_guest: 3,
    price: '1,60,909',
    currency: 'INR',
    email: 'australia@gmail.com',
    tags: ['Family trip', 'Adventure'],
  },
  {
    item_id: 4,
    trip_name: '12 Days India Trip',
    address: {
      city: 'Mumbai',
      country: 'India',
    },
    start_date: '10-04-2022',
    end_date: '10-12-2022',
    total_guest: 3,
    price: '1,60,909',
    currency: 'INR',
    email: 'india@gmail.com',
    tags: ['Family trip', 'Adventure'],
  },
  {
    item_id: 5,
    trip_name: '6 Days US Trip',
    address: {
      city: 'New York',
      country: 'United States',
    },
    start_date: '10-04-2022',
    end_date: '10-12-2022',
    total_guest: 3,
    price: '1,60,909',
    currency: 'INR',
    email: 'america@gmail.com',
    tags: ['Family trip', 'Adventure'],
  },
]
